import React, { useState, useEffect } from 'react'
import "./Style.css"
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { getSurveyDetails, Pastsession } from '../Utils/utils'
import Loader from '../../Component/Loader/Loader'
import moment from 'moment'

const SurveyDetail = () => {
  const [pastseesiondata, setPastSessionData] = useState([]);
  const [Loading, setLoading] = useState(false);
  // const { id } = useParams();
  let location = useLocation();
  let id = new URLSearchParams(location.search).get('id')
  const [detail, setDetail] = useState('');
  const navigate = useNavigate()

  const surveyDetailing = async () => {

    try {
      setLoading(true)
      const response = await getSurveyDetails(id);
      setDetail(response.data)
    } catch (error) {
      console.error("Error during Dashboard request:", error);

    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    if (id)
      surveyDetailing();
  }, [id]);
  console.log(detail?.positive_feedback)

  return (
    <>
      {Loading && <Loader />}
      <div className="Passbooking-top">
        <div className='booking-wrapper mx-auto'>
          <div className='booking-top-container p-4'>
            <Link to="/survey-dashboard" style={{ textDecoration: 'none' }}>
              <img
                className="img-fluid left-arrow-img"
                src="./Images/left-arrow.svg"
                alt="arrow"
              />
            </Link>

            <span className='title d-flex align-items-center justify-content-center mt-3'>Survey</span>
          </div>

          <div className='pastbooking-info p-3 pad-top'>
            {/* Past Bookings */}
            <div className="survey-name">{detail?.name ? detail?.name : detail?.full_name}</div>
            <div className='top-bottom-margin'>

              <span className='survey-age'>{detail?.age} Years</span>
              <span className='survey-age' style={{ textTransform: 'capitalize' }}>{detail?.gender}</span>
              <span className='survey-age'>{detail?.weight} Kgs</span>
              <span className='survey-age'>{detail?.height_foot}.{detail?.height_inch}ft</span>
              <span className='survey-age'>{detail?.occupation}</span>
              {detail?.email &&
                <span className='survey-age'>{detail?.email}</span>
              }
              <span className='survey-age'>{detail?.bmi} BMI</span>
            </div>

            <div className='phone-num'>+{detail?.phone_number}</div>
            <div className='row w-100 m-auto' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <div className='survey-date w-auto '>Surveyed on: <span style={{ color: '#000' }}>{moment(detail?.createdAt).format('DD MMM, YYYY')}</span></div>
              <button className='continue-btn-2 ' type='submit' onClick={() => navigate(`/surveystepone?id=${id}&edit=true`)}>
                <span className='continuebtn-text cont-font' >Edit Now</span>
              </button>
            </div>
            <div className='health-head'>Health History</div>
            <div className='survey-ques'>
              What symptoms brought you here today?
            </div>
            <div className='survey-ans'>
              {detail?.symptoms}
            </div>
            {/* 
            <div className='survey-ques'>
              When did the symptoms started?
            </div>
            <div className='survey-ans'>
              {detail?.symptoms_start_date}
            </div> */}

            <div className='survey-ques'>
              Any treatments taken?
            </div>
            <div className='survey-ans'>
              {detail?.ongoing_treatment}
            </div>

            <div className='survey-ques'>
              Any medical condition before?
            </div>
            <div className='survey-ans'>
              {detail?.medical_conditions_before}
            </div>

            <div className='survey-ques'>
              Any current medication or drug allergies?
            </div>
            <div className='survey-ans'>
              {detail?.medication_or_allergies}
            </div>

            <div className='survey-ques'>
              Any past surgeries or procedures?
            </div>
            <div className='survey-ans'>
              {detail?.past_surgeries}
            </div>

            <div className='survey-ques'>
              Pain level
            </div>
            <div className='survey-ans'>
              {detail?.pain_level}
            </div>

            {detail?.criterias && detail?.criterias.map((a, i) => (
              <>
                <div className='health-head mt-3'>Major Criteria {detail?.criterias.length > 1 && `(Problem ${i + 1})`}</div>
                <div className='survey-ques'>
                  Major Problem
                </div>
                <div className='survey-ans'>
                  {a?.major_problem}
                </div>
                <div className='survey-ques'>
                  Problem Statement
                </div>
                <div className='survey-ans'>
                  {a?.problem_statement}
                </div>
                <div className='survey-ques'>
                  Pre Test Evaluation
                </div>
                <div className='survey-ans'>
                  {a?.pre_test_evaluation}
                </div>
                <div className='survey-ques'>
                  Post Test Evaluation
                </div>
                <div className='survey-ans'>
                  {a?.post_test_evaluation}
                </div>
                <div className='survey-ques'>
                  Overall Results
                </div>
                <div className='survey-ans'>
                  {a?.overall_result}
                </div>

              </>
            ))}

            {detail?.positive_feedback || detail?.negative_feedback &&
              <div className='health-head mt-3'>Post Service Session Criteria</div>
            }
            {detail?.positive_feedback &&
              <>
                <div className='survey-ques'>
                  Positive result feedback
                </div>
                <div className='survey-ans'>
                  {detail?.positive_feedback}
                </div>
              </>}
            {detail?.negative_feedback &&
              <>
                <div className='survey-ques'>
                  Negative result feedback
                </div>
                <div className='survey-ans'>
                  {detail?.negative_feedback}
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </>


  )
}

export default SurveyDetail